/* eslint-disable */
import _ from 'underscore';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import filterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
import Model from '@bingads-webui-static-legacy/bulk-edit/model/label/association';
import ViewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/label/association';
import instrumentationSettings from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import pageContext from '@bingads-webui-static-legacy/page-context';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var deserialize = function (key) {
  return JSON.parse(key);
};
var getId = function (key) {
  var id = key.Id || key;
  return parseInt(id);
};
var getChanged = function (state, stats) {
  return _.keys(stats.changed).filter(function (key) {
    var change = stats.changed[key];
    return change.after.state === state;
  }).map(deserialize);
};
var getAdded = function (stats) {
  var changed = getChanged('checked', stats);
  var added = _.keys(stats.added || ({})).map(deserialize).concat(changed);
  return _.uniq(added);
};
var getRemoved = function (stats) {
  var changed = getChanged('unchecked', stats);
  var removed = _.keys(stats.removed).map(deserialize).concat(changed);
  return _.uniq(removed);
};
var getByScope = function (labels) {
  var result = {
    Account: [],
    Customer: []
  };
  labels.forEach(function (label) {
    if (!label.Scope || label.Scope !== 'Customer') {
      result.Account.push(label);
    } else {
      result.Customer.push(label);
    }
  });
  return result;
};
var view = BaseView.extend({
  initialize: function (options) {
    this._stats = options.stats;
    this._entity = options.entity;
    this._scope = options.scope;
    this._loadDirectlyLinkedAccounts = options.loadDirectlyLinkedAccounts;
    this.template = options.template;
    this._isManagementRequest = options.isManagementRequest;
    this.model = new Model();
    BaseView.prototype.initialize.apply(this, arguments);
    this.ko_model = new ViewModel(this.model);
  },
  render: (function () {
    if (this.grid.getSelectionScope() === 'AllPages') {
      this.ko_model.showProgress(true);
      this.ko_model.showButtonBar(false);
    } else {
      this.ko_model.showPanel = false;
    }
    BaseView.prototype.render.apply(this, arguments);
    this.submitJob();
    return this;
  }).asLoggingStart(instrumentationSettings.ACTIVITYNAME.LabelAssociation, instrumentationSettings.SCENARIONAME.LabelAssociation),
  renderBulkEditJobView: function () {
    BaseView.prototype.render.apply(this, arguments);
  },
  setAction: function () {
    var action = [];
    var added;
    var removed;
    var currentCustomerId;
    if (!this._scope || this._scope !== 'Customer') {
      currentCustomerId = pageContext.CurrentCustomer.Id;
    }
    if (!_.isEmpty(this._stats)) {
      added = getAdded(this._stats);
      removed = getRemoved(this._stats);
      if (added.length > 0) {
        const addedByScope = getByScope(added);
        if (addedByScope.Account.length > 0) {
          action.push({
            '@odata.type': '#Model.LabelAssociationAction',
            'AssociationList': addedByScope.Account.map(getId),
            'Scope': 'Account'
          });
        }
        if (addedByScope.Customer.length > 0) {
          action.push({
            '@odata.type': '#Model.LabelAssociationAction',
            'AssociationList': addedByScope.Customer.map(getId),
            'Scope': 'Customer'
          });
        }
      }
      if (removed.length > 0) {
        const removedByScope = getByScope(removed);
        if (removedByScope.Account.length > 0) {
          action.push({
            '@odata.type': '#Model.LabelDisassociationAction',
            'AssociationList': removedByScope.Account.map(getId),
            'Scope': 'Account'
          });
        }
        if (removedByScope.Customer.length > 0) {
          action.push({
            '@odata.type': '#Model.LabelDisassociationAction',
            'AssociationList': removedByScope.Customer.map(getId),
            'Scope': 'Customer'
          });
        }
      }
    }
    this.model.set('Entity', this._entity);
    this.model.set('BatchAction', {
      'Actions': action
    });
    this.model.set('currentCustomerIdFirst', true);
    if (this._entity === 'Account' && this.selectionInfo.allPages) {
      this._isManagementRequest = this._isManagementRequest || false;
      var RequestProperties = [{
        'Key': 'IsManagementRequest',
        'Value': this._isManagementRequest + ''
      }, {
        'Key': 'LoadDirectlyLinkedAccounts',
        'Value': this._loadDirectlyLinkedAccounts
      }];
      this.model.set('RequestProperties', RequestProperties);
    }
    if (currentCustomerId) {
      this.model.set('CurrentCustomerId', currentCustomerId);
    }
  },
  getIdFilter: function () {
    var isCustomerLevelLabel = this._scope && this._scope === 'Customer';
    return isCustomerLevelLabel ? filterHelper.getIdFilterNoEntityType(this.grid) : filterHelper.getIdFilter(this.grid, this._entity);
  },
  getProgressText: function () {
    return i18n.getString('label_progress_text');
  }
});
export default view;

